import { GdEmitBothValuesOnChangeDirective } from '../attributes/gd-emit-both-values-on-change.directive';
import { GdEmitBothValuesOnEveryChangeDirective } from '../attributes/gd-emit-both-values-on-every-change.directive';
import { GdShowOnChangeDirective } from '../attributes/gd-show-on-change.directive';
import { GdFieldInputtextComponent } from './inputtext/gd-field-inputtext.component';
import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {GdFieldDropdownComponent} from "./dropdown/gd-field-dropdown.component";
import {EfastFieldInputtextComponent} from "./efast/inputText/efast-field-inputtext.component";
import {EfastErrormessageComponent} from "./efast/errormessage/efast-errormessage.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule
	],
	declarations: [
		GdShowOnChangeDirective,
		GdEmitBothValuesOnChangeDirective,
        GdEmitBothValuesOnEveryChangeDirective,
		GdFieldInputtextComponent,
		GdFieldDropdownComponent,
		EfastFieldInputtextComponent,
		EfastErrormessageComponent
	],
	exports: [
		GdShowOnChangeDirective,
		GdEmitBothValuesOnChangeDirective,
        GdEmitBothValuesOnEveryChangeDirective,
		GdFieldInputtextComponent,
		GdFieldDropdownComponent,
		EfastFieldInputtextComponent,
		EfastErrormessageComponent
	]
})
export class GdInputsModule { }
